import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class RegistrationsDetailsFormStateCloudAccount extends FormStateBase {
    accountId: FormFieldState = new FormFieldState();
    ban: FormFieldState = new FormFieldState();
    companyName: FormFieldState = new FormFieldState();
    cidn: FormFieldState = new FormFieldState();

    constructor() {
        super();
        this.setForm(this);
    }
}
